import Bullhorn20 from '@carbon/icons-react/es/bullhorn/20';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { StatusUpdatePreview } from 'api/notifications';
import { Tag } from 'components/atoms/tag';
import { ShowForVendor } from 'components/atoms/user-type-utils';
import { Header } from './components';
import styles from './group.module.css';

interface Props {
  statusUpdate: StatusUpdatePreview;
}

const Icon = styled(Bullhorn20)`
  margin-right: var(--spacing-04);
  color: var(--blue-60);
`;

export const StatusUpdateHeader: FC<Props> = ({
  statusUpdate: { name, project, autoPublished },
  children,
}) => {
  return (
    <Header className={styles.header}>
      <Header.Primary>
        <Icon />
        <Header.PrimaryBlock>
          <div title={name} className={`${styles.title} ${styles.ellipsis}`}>
            {name}
          </div>
          <div className={`${styles.subtitle} ${styles.ellipsis}`}>
            {project.name}
          </div>
        </Header.PrimaryBlock>
        {autoPublished ? (
          <ShowForVendor>
            <Header.Tags>
              <Tag color="teal">
                <FormattedMessage id="auto_published" />
              </Tag>
            </Header.Tags>
          </ShowForVendor>
        ) : null}
      </Header.Primary>
      <Header.Hanger>{children}</Header.Hanger>
    </Header>
  );
};
